/** @format */
import { css } from 'styled-components';

import { GridRepeaterProps } from '.';
import { getMediaMatchedGridColumns } from './helpers';

export const generateGridTemplateAreas = (
    gridColumns: Required<GridRepeaterProps>['gridColumns']
) => {
    const gridTemplateAreas = Array(getMediaMatchedGridColumns(gridColumns))
        .fill('.')
        .join(' ');

    return css`
        grid-template-areas: ${gridTemplateAreas};
    `;
};
